"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TitleBar_1 = __importDefault(require("./TitleBar"));
exports.default = TitleBar_1.default;
